var map = {
	"./account-ico-mail.svg": 813,
	"./account-ico-pass.svg": 814,
	"./account-ico-phone.svg": 815,
	"./bank-transfer.svg": 816,
	"./betnearn-ico.svg": 817,
	"./birthday-bonus-ico.svg": 818,
	"./bonus-code-ico.svg": 819,
	"./bonus-ico.svg": 820,
	"./bonus-received-ico.svg": 821,
	"./business-account-upgrade-ico.svg": 822,
	"./check-in-daily-ico.svg": 823,
	"./checked.svg": 824,
	"./cloud-pointer.svg": 825,
	"./crypto.svg": 826,
	"./daily-bonus-ico.svg": 827,
	"./deposit-delay-bonus-ico.svg": 828,
	"./e-wallet.svg": 829,
	"./earn-coin-ico.svg": 830,
	"./earn-x33-coin-ico.svg": 831,
	"./email.svg": 832,
	"./facebook.svg": 833,
	"./feedback.svg": 834,
	"./first-bet-ico.svg": 835,
	"./games-rebate-ico.svg": 836,
	"./info.svg": 837,
	"./instagram.svg": 838,
	"./instant-rebate.svg": 839,
	"./live-casino-rebate-ico.svg": 840,
	"./lucky-spin-ico.svg": 841,
	"./messenger.svg": 842,
	"./mobile-app-deposit-ico.svg": 843,
	"./msg-activity.svg": 844,
	"./msg-ann.svg": 845,
	"./msg-notice.svg": 846,
	"./new-icon.svg": 847,
	"./people-ico.svg": 848,
	"./quick-pay.svg": 849,
	"./r77-coin.svg": 850,
	"./rescue-bonus-ico.svg": 851,
	"./rescue-lc-ico.svg": 852,
	"./rescue-slots-ico.svg": 853,
	"./return.svg": 854,
	"./sc-bc-active-ico.svg": 855,
	"./sc-bc-ico.svg": 856,
	"./sc-bi-active-ico.svg": 857,
	"./sc-bi-ico.svg": 858,
	"./sc-mail-active-ico.svg": 859,
	"./sc-mail-ico.svg": 860,
	"./sc-mp-active-ico.svg": 861,
	"./sc-mp-ico.svg": 862,
	"./sc-pin-active-ico.svg": 863,
	"./sc-pin-ico.svg": 864,
	"./slots-rebate-ico.svg": 865,
	"./sports-rebate-ico.svg": 866,
	"./telegram.svg": 867,
	"./twitter.svg": 868,
	"./vip-up-level-ico.svg": 869,
	"./vip-weekly-bonus.svg": 870,
	"./wallet-ico.svg": 871,
	"./weekly-tournament-ico.svg": 872,
	"./welcome-bonus-ico.svg": 873,
	"./whatsapp.svg": 874,
	"./withdrawal-delay-bonus-ico.svg": 875,
	"./x33-coin.svg": 876
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65;